import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import SmoothScroll from "@/components/common/SmoothScroll";
import Layout from "@/components/layout/Layout";

import Home from "@/pages/Home";
import About from "@/pages/About";
import SourcingServices from "@/pages/SourcingServices";
import TradingServices from "@/pages/TradingServices";
import Logistics from "@/pages/Logistics";
import Markets from "@/pages/Markets";
import HowItWorks from "@/pages/HowItWorks";
import IndustriesPage from "@/pages/IndustriesPage";
import Insights from "@/pages/Insights";
import InsightPost from "@/pages/InsightPost";
import RequestQuote from "@/pages/RequestQuote";
import RateQuote from "@/pages/RateQuote";
import Track from "@/pages/Track";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import CookieNotice from "@/pages/CookieNotice";
import Disclaimer from "@/pages/Disclaimer";
import NotFound from "@/pages/NotFound";
import Admin from "@/pages/Admin";

const withLayout = (el) => <Layout>{el}</Layout>;

function AppRouter() {
  return (
    <Routes>
      {/* Admin (no marketing chrome) */}
      <Route path="/admin" element={<Admin />} />

      {/* Marketing site */}
      <Route path="/" element={withLayout(<Home />)} />
      <Route path="/about" element={withLayout(<About />)} />
      <Route path="/sourcing-services" element={withLayout(<SourcingServices />)} />
      <Route path="/trading-services" element={withLayout(<TradingServices />)} />
      <Route path="/logistics-coordination" element={withLayout(<Logistics />)} />
      <Route path="/markets" element={withLayout(<Markets />)} />
      <Route path="/how-it-works" element={withLayout(<HowItWorks />)} />
      <Route path="/industries" element={withLayout(<IndustriesPage />)} />
      <Route path="/insights" element={withLayout(<Insights />)} />
      <Route path="/insights/:slug" element={withLayout(<InsightPost />)} />
      <Route path="/request-a-quote" element={withLayout(<RequestQuote />)} />
      <Route path="/rate-quote" element={withLayout(<RateQuote />)} />
      <Route path="/track" element={withLayout(<Track />)} />
      <Route path="/contact" element={withLayout(<Contact />)} />
      <Route path="/thank-you" element={withLayout(<ThankYou />)} />
      <Route path="/privacy-policy" element={withLayout(<PrivacyPolicy />)} />
      <Route path="/terms-of-use" element={withLayout(<TermsOfUse />)} />
      <Route path="/cookie-notice" element={withLayout(<CookieNotice />)} />
      <Route path="/disclaimer" element={withLayout(<Disclaimer />)} />
      <Route path="*" element={withLayout(<NotFound />)} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SettingsProvider>
          <AuthProvider>
            <SmoothScroll />
            <AppRouter />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
